<ul class="attachment-list">
  @for (a of attachments(); track a.attachmentGuid) {
    <li class="attachment">
      <!-- The link is cross-origin and signed, so no `download` attribute: the browser
           ignores it there, and the API already sets Content-Disposition. -->
      @if (a.url) {
        @if (isImage(a)) {
          <a class="attachment-thumb" [href]="a.url" target="_blank" rel="noopener">
            <img [src]="a.url" [alt]="a.fileName" loading="lazy" />
          </a>
        }
        <div class="attachment-meta">
          <a
            class="attachment-name"
            [href]="a.url"
            target="_blank"
            rel="noopener"
            [title]="a.fileName"
          >
            {{ a.fileName }}
          </a>
          <span class="attachment-size">{{ formatSize(a.fileSizeBytes) }}</span>
        </div>
      } @else {
        <div class="attachment-meta">
          <span class="attachment-name" [title]="a.fileName">{{ a.fileName }}</span>
          <span class="attachment-size">{{ formatSize(a.fileSizeBytes) }}</span>
        </div>
        <!-- The file is stored; only its signed link is missing. Nothing to act on from
             here — reopening the result asks the API for a new one. -->
        <div class="attachment-warn">Link unavailable.</div>
      }
    </li>
  } @empty {
    <li class="attachment-empty">No files attached.</li>
  }
</ul>
